import React from 'react'
import ProductUnavailable from './ProductUnavailable'
import InputAndAddtoCartUI from './InputAndAddtoCartUI'
import UOMUI from './UOMUI'
import InventoryUI from './InventoryUI'
import PriceUI from './PriceUI'
import FavSection from '../FavSection'
import { TrendingUpOutlined } from '@mui/icons-material'
import AuthroizedImages from '../AuthroizedImages'
import { Dialog } from 'primereact/dialog'

const ProductViewDialog = React.memo(
    ({ selectedProduct, isDialogVisible, setDialogVisible, count, setCount, updateChoosingUOM, InventoryStatus, handleCloseDialog,
        ProductRelatedStates }) => {
        return (
            <Dialog header="Product Detail" visible={isDialogVisible} onHide={() => handleCloseDialog()} style={{ width: '50vw' }} >
                <div className=" w-100  flex  justify-content-center ">

                    {/* image section  */}
                    <div className="w-50 flex justify-content-center align-items-center px-2">
                        <AuthroizedImages ProductImage={selectedProduct.Product.ProductImage} />
                    </div>


                    <div className=" w-50 gap-2  flex flex-column justify-content-evenly">
                        {/* ProductName */}
                        <div className="text-xl font-bold flex justify-content-start gap-2 align-items-end">

                            {selectedProduct.Product.ProductName}

                            {selectedProduct.Product.ProductStatus === "Trending" && (
                                <div className="pb-1">
                                    <TrendingUpOutlined className="glowing text-sm md:text-base"
                                        style={{ boxShadow: "none" }}
                                    />
                                </div>
                            )}

                            <FavSection ProductID={selectedProduct.Product.id} />

                        </div>

                        {/* ProductDetailDescription */}
                        <div>
                            <p className="text-sm text-gray-500 md:text-base leading-relaxed whitespace-normal max-w-2/4">
                                {selectedProduct.Product.ProductDetailDescription || 'Product description is unavailable'}
                            </p>
                        </div>

                        {/* ProductPrice */}
                        <PriceUI PriceDetails={selectedProduct.ProductCardState.PriceDetails} ProductsUOMDetails={ProductRelatedStates.ProductsUOMDetails}
                            priceClass="text-4xl"
                        />

                        {/* Inventory details  */}
                        {InventoryStatus && <InventoryUI QtyDetails={selectedProduct.ProductCardState.QtyDetails} />}

                        {/* UOM Section  */}
                        {(selectedProduct.ProductCardState.PriceDetails.ButtonStatus === "AddtoCart" &&
                            selectedProduct.ProductCardState.QtyDetails.Status === "InStock" && selectedProduct.ProductCardState.QtyDetails.CurrentStock > 0) &&
                            <UOMUI UOMProductDetails={selectedProduct.Product.ProductQuantityDetails}
                                ProductUOM={selectedProduct.Product.ProductUOM} updateChoosingUOM={updateChoosingUOM} />
                        }
                        {/* Input box and Add To Cart Button  */}
                        {(selectedProduct.ProductCardState.PriceDetails.ButtonStatus === "AddtoCart" && selectedProduct.ProductCardState.QtyDetails.Status === "InStock" &&
                            selectedProduct.ProductCardState.QtyDetails.CurrentStock > 0) &&
                            <InputAndAddtoCartUI selectedProduct={selectedProduct} count={count} setCount={setCount} setDialogVisible={setDialogVisible} />
                        }

                        {/* Unavailable Product view  */}
                        {selectedProduct.ProductCardState.PriceDetails.ButtonStatus === "Unavailable" &&
                            <ProductUnavailable />
                        }

                    </div>

                </div>
            </Dialog>
        )
    }
)

export default ProductViewDialog